module.exports = __webpack_public_path__ + "img/dots-icon.fbacb7da.svg";